import { Grid, Paper, } from '@mui/material';
import { PropsWithChildren } from 'react';

function CommonPaperWrapper({ children }: PropsWithChildren<{}>){
  return (

    <Paper sx={{ p: '0.7rem 1rem', }}>
      <Grid 
        container 
        justifyContent="center" 
      >
        {children}
      </Grid>
    </Paper>
  )
}

export default CommonPaperWrapper;
